import { BlankUnit } from "./types";

export const statuses = [
  { value: false, label: "Available" },
  { value: true, label: "Occupied" }
];

export const unitStatus = (occupied: boolean) =>
  occupied ? "Occupied" : "Available";
